// const navCol = document.querySelector(".nav-col");
// const menuBtn = document.querySelector("#mobile-menu-btn");
// const overlay = document.querySelector(".overlay");
//
// const nav = document.getElementById("nav-main");
//
//
// function toggleMenu() {
//     navCol.classList.toggle("open");
//     overlay.classList.toggle("open");
//     this.classList.toggle("open");
// }
// function closeMenu() {
//     navCol.classList.remove("open");
//     menuBtn.classList.remove("open");
//     overlay.classList.remove("open");
// }
//
// document.addEventListener("keyup", function (e) {
//     if (e.key === "Escape") closeMenu();
// });
// document.addEventListener("click", function () {
//     if (navCol.classList.contains("open")) {
//         overlay.classList.add("open");
//     }
// });
//
//
// const mq = window.matchMedia("screen and (min-width: 1025px)");
//
// mq.addEventListener("change", event => {
//     if (event.matches) {
//         closeMenu();
//     }
// })
//
// menuBtn.addEventListener("click", toggleMenu);
// overlay.addEventListener("click", closeMenu);
